import React from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '../../ui/input';

const pad = (n) => String(n).padStart(2, '0');
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const presets = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  return [
    { id: 'all', label: 'Todo', fecha_inicio: '', fecha_fin: '' },
    { id: 'month', label: 'Este mes', fecha_inicio: ymd(new Date(y, m, 1)), fecha_fin: ymd(new Date(y, m + 1, 0)) },
    { id: 'prev', label: 'Mes pasado', fecha_inicio: ymd(new Date(y, m - 1, 1)), fecha_fin: ymd(new Date(y, m, 0)) },
    { id: 'quarter', label: 'Trimestre', fecha_inicio: ymd(new Date(y, Math.floor(m / 3) * 3, 1)), fecha_fin: ymd(new Date(y, Math.floor(m / 3) * 3 + 3, 0)) },
    { id: 'year', label: 'Este año', fecha_inicio: `${y}-01-01`, fecha_fin: `${y}-12-31` },
  ];
};

const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const monthOptions = () => {
  const now = new Date();
  return Array.from({ length: 24 }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    return { label: `${MONTHS[d.getMonth()]} ${d.getFullYear()}`, fecha_inicio: ymd(d), fecha_fin: ymd(new Date(d.getFullYear(), d.getMonth() + 1, 0)) };
  });
};

const MonthSelect = ({ filters, set }) => {
  const opts = monthOptions();
  const current = opts.find(o => o.fecha_inicio === filters.fecha_inicio && o.fecha_fin === filters.fecha_fin);
  return (
    <select value={current?.fecha_inicio || ''} onChange={e => { const o = opts.find(x => x.fecha_inicio === e.target.value); if (o) set({ fecha_inicio: o.fecha_inicio, fecha_fin: o.fecha_fin }); }}
      className={`h-8 rounded-full border px-3 text-sm font-medium ${current ? 'bg-gray-900 text-white border-gray-900' : 'bg-gray-100 text-gray-700 border-transparent'}`} data-testid="expense-detail-month">
      <option value="">Elegir mes…</option>
      {opts.map(o => <option key={o.fecha_inicio} value={o.fecha_inicio}>{o.label}</option>)}
    </select>
  );
};

export const DetailFilters = ({ filters, setFilters, vendorOptions, hideVendor }) => {
  const set = (patch) => setFilters(f => ({ ...f, ...patch }));
  const active = presets().find(p => p.fecha_inicio === filters.fecha_inicio && p.fecha_fin === filters.fecha_fin);

  return (
    <div className="bg-white rounded-xl border shadow-sm p-3 space-y-3" data-testid="expense-detail-filters">
      <div className="flex flex-wrap gap-2">
        {presets().map(p => (
          <button key={p.id} onClick={() => set({ fecha_inicio: p.fecha_inicio, fecha_fin: p.fecha_fin })}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${active?.id === p.id ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
            data-testid={`expense-detail-preset-${p.id}`}>
            {p.label}
          </button>
        ))}
        <MonthSelect filters={filters} set={set} />
      </div>
      <div className={`grid grid-cols-2 gap-2 ${hideVendor ? "md:grid-cols-3" : "md:grid-cols-4"}`}>
        <Input type="date" value={filters.fecha_inicio} onChange={e => set({ fecha_inicio: e.target.value })} data-testid="expense-detail-from" />
        <Input type="date" value={filters.fecha_fin} onChange={e => set({ fecha_fin: e.target.value })} data-testid="expense-detail-to" />
        {!hideVendor && <select value={filters.proveedor} onChange={e => set({ proveedor: e.target.value })}
          className="h-9 rounded-md border border-input bg-transparent px-3 text-sm" data-testid="expense-detail-vendor">
          <option value="">Todos los proveedores</option>
          {vendorOptions.map(v => <option key={v} value={v}>{v}</option>)}
        </select>}
        <div className="relative">
          <Search size={15} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
          <Input className="pl-8 pr-8" placeholder="Buscar concepto, nº…" value={filters.q} onChange={e => set({ q: e.target.value })} data-testid="expense-detail-search" />
          {filters.q && (
            <button onClick={() => set({ q: '' })} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400" data-testid="expense-detail-search-clear"><X size={15} /></button>
          )}
        </div>
      </div>
    </div>
  );
};
